import { render, staticRenderFns } from "./Pie.vue?vue&type=template&id=92027b4a"
import script from "./Pie.vue?vue&type=script&lang=js"
export * from "./Pie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92027b4a')) {
      api.createRecord('92027b4a', component.options)
    } else {
      api.reload('92027b4a', component.options)
    }
    module.hot.accept("./Pie.vue?vue&type=template&id=92027b4a", function () {
      api.rerender('92027b4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chart/Pie.vue"
export default component.exports